
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { StartLink } from "../../data/Navigation";
import { INavigationLink } from "../../interfaces/INavigation";
import { useCallback } from 'react';
import { useUserContext } from "../UserContext";
import NavigationHelper from "../../helpers/NavigationHelper";
import FormHelper from "../../helpers/FormHelper";
import UserService from "../../services/UserService";


interface INavigationContext {
    selectedNavigationLink: INavigationLink;
    setSelectedNavigationLink: (navLink: INavigationLink) => void;
}


const NavigationContext = createContext<INavigationContext | undefined>(undefined);

const NavigationContextProvider = (props: React.PropsWithChildren) => {
    const { userPermissions } = useUserContext();

    const [selectedNavigationLink, setSelectedNavigationLink] = useState<INavigationLink>(StartLink);

    useEffect(() => {
        const navigationItems = NavigationHelper.FilterItems(n => userPermissions.includes(n.alias[0]));
        if (navigationItems.length === 1) {
            setSelectedNavigationLink(navigationItems[0]);
        }
    }, [userPermissions]);


    const handleChangeSelectedNavigationLink = useCallback((navLink: INavigationLink) => {
        if (navLink.alias.length > 0) {
            let formData = FormHelper.Create(undefined);
            formData = FormHelper.Add(formData, 'permissionAlias', navLink.alias[0]);

            UserService.UpdateRecentAccess(formData);
        }

        setSelectedNavigationLink(navLink);
        // eslint-disable-next-line
    }, []);

    

    const data: INavigationContext = useMemo(() => {
        return {
            selectedNavigationLink,
            setSelectedNavigationLink: handleChangeSelectedNavigationLink
        };

        // eslint-disable-next-line
    }, [selectedNavigationLink]);

    return (
        <NavigationContext.Provider value={data}>
            {props.children}
        </NavigationContext.Provider>
    );
}


const useNavigationContext = () => {
    const context = useContext(NavigationContext);

    if (context === undefined) {
        throw new Error('useNavigationContext must be used within a NavigationContextProvider');
    }

    return context;
}

export {
    useNavigationContext
}

export default NavigationContextProvider;